import {
    REMOVE_ATP_WORKOUT,
    UPDATE_ADAPTIVE_PLAN_STATUS,
    UPDATE_ADAPTIVE_PLAN_STATUS_SUCCESS,
    UPDATE_ADAPTIVE_PLAN_STATUS_ERROR,
    FETCH_PLAN_CONTENT,
    FETCH_COACH_CAUTION,
    FETCH_PREPLAN_DISTANCE,
    FETCH_PREPLAN_PACE,
    FETCH_PREPLAN_GOALS,
    FETCH_PREPLAN_PACE_TIMES,
    FETCH_PREPLAN_COACHES,
    FETCH_PREPLAN_COACH_INFO,
    FETCH_COACH_VIDEO,
    RESET_PREPLAN_DISTANCE,
    RESET_PREPLAN_PACE_TIMES,
    RESET_PREPLAN_PACE,
    RESET_COACH_VIDEO
} from './ActionTypes';
import { atpApi } from 'config/axios';

export const PAUSE_ATP_PLAN = 'PAUSE_ATP_PLAN';
export const RESUME_ATP_PLAN = 'RESUME_ATP_PLAN';
export const REACT_TO_COACH = 'REACT_TO_COACH';
export const QUIT_ATP_PLAN = 'QUIT_ATP_PLAN';
export const COMPLETE_ATP_PLAN = 'COMPLETE_ATP_PLAN';

/**
 * ATP Daily Experience Page
 */
export const removeATPWorkout = (athletePlanId, scheduleWorkoutId) => {
    if (athletePlanId) {
        return atpApi.delete(`/atp/athlete/plan/schedule/${athletePlanId}/${scheduleWorkoutId}`);
    }
};

export const rescheduleATPWorkout = (athletePlanId, scheduleWorkoutId, newDate) => {
    if (athletePlanId) {
        return atpApi.put(
            `/atp/athlete/plan/reschedule?athletePlanId=${athletePlanId}&scheduleWorkoutId=${scheduleWorkoutId}&newDate=${newDate}`
        );
    }
};

export const updateAtpPlanStatusAction = (data) => {
    let request = {
        type: UPDATE_ADAPTIVE_PLAN_STATUS
    };

    if (data) {
        for (var i in data) {
            if (data.hasOwnProperty(i) && data[i]) {
                request[i] = data[i];
            }
        }
    }

    return request;
};

export const updateAtpPlanStatusSuccessAction = (response, planStatus, atpPlan) => {
    return {
        type: UPDATE_ADAPTIVE_PLAN_STATUS_SUCCESS,
        response: response.data,
        planStatus: planStatus,
        atpPlan: atpPlan
    };
};

export const updateAtpPlanStatusErrorAction = (error) => {
    return {
        type: UPDATE_ADAPTIVE_PLAN_STATUS_ERROR,
        error: error
    };
};

export function pauseAtpPlan(athletePlanId, callback) {
    return {
        type: PAUSE_ATP_PLAN,
        athletePlanId,
        callback
    };
}

export const unPauseAtpPlan = (athletePlanId, reason, callback) => ({
    type: RESUME_ATP_PLAN,
    athletePlanId,
    reason,
    callback
});

export const quitAtpPlan = (athletePlanId, callback) => ({
    type: QUIT_ATP_PLAN,
    athletePlanId,
    callback
});

export const completeAtpPlan = (athletePlanId) => ({
    type: COMPLETE_ATP_PLAN,
    athletePlanId
});

export const reactToCoach = (athletePlanId, actionId, actionOptionId, callback) => ({
    type: REACT_TO_COACH,
    athletePlanId,
    actionId,
    actionOptionId,
    callback
});

export const fetchPlanContent = ({ workoutPlanTypeId, lang }) => ({
    type: FETCH_PLAN_CONTENT,
    workoutPlanTypeId,
    lang
});

export const fetchCoachCaution = ({
    planTypeId,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    selectedGoal,
    selectedPaceGoalTime,
    callback
}) => ({
    type: FETCH_COACH_CAUTION,
    planTypeId,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    selectedGoal,
    selectedPaceGoalTime,
    callback
});

export const fetchPreplanDistance = ({ workoutPlanTypeId, unitType }) => ({
    type: FETCH_PREPLAN_DISTANCE,
    workoutPlanTypeId,
    unitType
});

export const resetPreplanDistance = () => ({
    type: RESET_PREPLAN_DISTANCE
});

export const fetchPreplanPace = ({ workoutPlanTypeId, unitType }) => ({
    type: FETCH_PREPLAN_PACE,
    workoutPlanTypeId,
    unitType
});

export const resetPreplanPace = () => ({
    type: RESET_PREPLAN_PACE
});

export const fetchPreplanGoals = ({ workoutPlanTypeId, prePlanWeeklyMileage, prePlanTrainingPace, lang }) => ({
    type: FETCH_PREPLAN_GOALS,
    workoutPlanTypeId,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    lang
});

export const fetchPreplanPaceTimes = ({ workoutPlanTypeId, prePlanWeeklyMileage, prePlanTrainingPace, lang }) => ({
    type: FETCH_PREPLAN_PACE_TIMES,
    workoutPlanTypeId,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    lang
});

export const resetPreplanPaceTimes = () => ({
    type: RESET_PREPLAN_PACE_TIMES
});

export const fetchPreplanCoaches = ({
    workoutPlanTypeId,
    goal,
    raceGoalTime,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    lang,
    callback
}) => ({
    type: FETCH_PREPLAN_COACHES,
    workoutPlanTypeId,
    goal,
    raceGoalTime,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    lang,
    callback
});

export const fetchPreplanCoachInfo = ({ contentfulContentId, fields, lang }) => ({
    type: FETCH_PREPLAN_COACH_INFO,
    contentfulContentId,
    fields,
    lang
});

export const fetchCoachInfoWithVideo = ({ coachKey, videoKey, lang }) => ({
    type: FETCH_COACH_VIDEO,
    coachKey,
    videoKey,
    lang
});

export const resetCoachInfoWithVideo = () => ({
    type: RESET_COACH_VIDEO
});
